import { render } from "./MainTireCategorySearchComponent.vue?vue&type=template&id=06e7f160&scoped=true"
import script from "./MainTireCategorySearchComponent.vue?vue&type=script&lang=js"
export * from "./MainTireCategorySearchComponent.vue?vue&type=script&lang=js"

import "./MainTireCategorySearchComponent.vue?vue&type=style&index=0&id=06e7f160&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e7f160"]])

export default __exports__